import { gql } from '@apollo/client';
import { TRANSLATED_STRING_FIELDS } from './common';
import { PIECE_REFERENCE_FIELDS } from './piece';
import { ACCESSORY_REFERENCE_FIELDS } from './accessory';
import { PRICING_CATALOG_FIELDS } from './pricing';
import { MERCHANT_DELIVERY_FIELDS, PLATFORM_PRODUCER_CONTRACT_FIELDS } from './contract';

// --------------------------------------------------------- Piece inventory ---------------------------------------------------------

export const DELIVERY_UNIT_PIECE_INVENTORY_FIELDS = gql`
  fragment DeliveryUnitPieceInventoryStatsFields on DeliveryUnitPieceInventoryStats {
    existingPieceInventoryCount
    maximumPieceInventoryCount
  }
`;

export const PIECE_INVENTORY_FIELDS = gql`
  ${TRANSLATED_STRING_FIELDS}
  ${PIECE_REFERENCE_FIELDS}
  fragment PieceInventoryFields on PieceInventory {
    id
    partyId
    deliveryUnitId
    pieceTitle {
      ...TranslatedStringFields
    }
    pieceReference {
      ...PieceReferenceFields
    }
    inventoryReference
    createdAt
    updatedAt
  }
`;
// --------------------------------------------------------- Accessory Inventory ---------------------------------------------------------

export const DELIVERY_UNIT_ACCESSORY_INVENTORY_FIELDS = gql`
  fragment DeliveryUnitAccessoryInventoryStatsFields on DeliveryUnitAccessoryInventoryStats {
    existingAccessoryInventoryCount
    maximumAccessoryInventoryCount
  }
`;

export const ACCESSORY_INVENTORY_FIELDS = gql`
  ${TRANSLATED_STRING_FIELDS}
  ${ACCESSORY_REFERENCE_FIELDS}
  fragment AccessoryInventoryFields on AccessoryInventory {
    id
    partyId
    deliveryUnitId
    accessoryTitle {
      ...TranslatedStringFields
    }
    accessoryReference {
      ...AccessoryReferenceFields
    }
    inventoryReference
    createdAt
    updatedAt
  }
`;

// --------------------------------------------------------- Delivery Unit ---------------------------------------------------------

export const DELIVERY_UNIT_INVENTORY_CATALOG_FIELDS = gql`
  ${PIECE_INVENTORY_FIELDS}
  ${ACCESSORY_INVENTORY_FIELDS}
  fragment DeliveryUnitInventoryCatalogFields on DeliveryUnitInventoryCatalog {
    pieceInventorys {
      ...PieceInventoryFields
    }
    accessoryInventorys {
      ...AccessoryInventoryFields
    }
  }
`;

// --------------------------------------------------------- Delivery unit sale catalog ---------------------------------------------------------
export const DELIVERY_UNIT_SALE_CATALOG_FIELDS = gql`
  ${TRANSLATED_STRING_FIELDS}
  ${DELIVERY_UNIT_INVENTORY_CATALOG_FIELDS}
  ${PRICING_CATALOG_FIELDS}
  fragment DeliveryUnitSaleCatalogFields on DeliveryUnitSaleCatalog {
    id
    partyId
    deliveryUnitId
    name {
      ...TranslatedStringFields
    }
    description {
      ...TranslatedStringFields
    }
    pricingCatalogs {
      ...PricingCatalogFields
    }
    inventoryCatalog {
      ...DeliveryUnitInventoryCatalogFields
    }
    createdAt
    publishedAt
    updatedAt
  }
`;

export const DELIVERY_UNIT_SALE_CATALOG_WITH_PLATFORM_PRODUCER_CONTRACT_FIELDS = gql`
  ${DELIVERY_UNIT_SALE_CATALOG_FIELDS}
  ${PLATFORM_PRODUCER_CONTRACT_FIELDS}
  fragment DeliveryUnitSaleCatalogWithPlatformProducerContractFields on DeliveryUnitSaleCatalogWithPlatformProducerContract {
    deliveryUnitSaleCatalog {
      ...DeliveryUnitSaleCatalogFields
    }
    platformProducerContract {
      ...PlatformProducerContractFields
    }
    deliveryUnitSaleCatalogPublished
    platformProducerContractActive
  }
`;
